import { useState, useEffect } from 'react';
import Combobox from './Combobox';
import './ReactTreeGridCssImport';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ColumnDirective, ColumnsDirective, TreeGridComponent, Page, Filter, Inject, FilterSettingsModel } from '@syncfusion/ej2-react-treegrid';
import { useAuth } from './auth/AuthContext';

export function TreeGridDemo() {
    //Ref: https://www.syncfusion.com/react-components/react-tree-grid
    //Ref: https://www.npmjs.com/package/@syncfusion/ej2-react-treegrid
    //Ref: https://communitylicense.syncfusion.com/support/tickets/705836
    var [archivesList, setArchivesList] = useState([]);
    var [srchArchiveName, setSrchArchiveName] = useState('');
    var [srchFolderName, setSrchFolderName] = useState('');
    var [srchVidName, setSrchVidName] = useState('');
    var [videosData, setVideosData] = useState([]);
    const [loading, setLoading] = useState('');
    const { secureFetch } = useAuth();

    //Ref: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
    async function fetchArchivesList() {
        setLoading('loading');
        let url = 'api/mediasearcher';
        const response = await secureFetch(url);
        if (response.ok) {
            const data = await response.json();
            let comboData = data.map((archive) => {
                return { value: archive, text: archive };
            }); 
            comboData.unshift({ value: '', text: 'Select an archive' });
            setArchivesList(comboData);
            if (comboData.length > 0)
                setSrchArchiveName(comboData[0].value);
        }
        else {
            console.error('Error in fetch call:', response.status, response.statusText);
        }
        setLoading('');
    }

    async function onArchiveSelect(e) {
        let foundArchive = archivesList.find(c => c.value === e.target.value);
        if (foundArchive) {
            setSrchArchiveName(foundArchive.text);
            console.log(`You selected archive - ${foundArchive.text}`);
        }
        else {
            setSrchArchiveName(null);
            console.log('You selected archive - none');
        }
    }

    async function fetchVideosData() {
        let url = 'api/mediasearcher/SearchFileArchiveHierarchy';
        let params = { };            
        if (srchArchiveName) {
            params.archiveName = srchArchiveName;
        }
        if (srchFolderName) {
            params.folderName = srchFolderName;
        }
        if (srchVidName) {
            params.query = srchVidName;
        }

        setLoading('loading');
        const response = await secureFetch(url, {
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams(params).toString()
        });
        if (response.ok) {
            const data = await response.json();
            populateHierarchyAttributes(data);
            setVideosData(data);
        }
        else {
            console.error('Error in fetch call:', response.status, response.statusText);
        }
        setLoading('');
    }

    function populateHierarchyAttributes(data) {
        data.forEach((fileItem) => {
            fileItem.creationDate = new Date(fileItem.creationDate);
            fileItem.size = formatFileSize(fileItem.size);
            if (fileItem.children.length > 0) {
                populateHierarchyAttributes(fileItem.children);
            }
        });
    }

    function formatFileSize(size) {
        if (!size) return null;

        let unit = 'bytes';
        if (size > 1024) {
            size /= 1024;
            unit = 'KB';
        }
        if (size > 1024) {
            size /= 1024;
            unit = 'MB';
        }
        return `${Math.round(size)} ${unit}`;
    }
    useEffect(() => {
        //Populate the Archives combobox by default
        fetchArchivesList();
    }, []);
    

    return (
        <div className={`container ${loading}`}>
            <h2>Browse Archive File Information</h2>
            <div class="row mb-2 mt-3">
                <div className="col-sm-2">
                    <label htmlFor="srchArchiveName">Archive Name:</label>
                </div>
                <div className="col-sm-4">
                    <Combobox title="Archives" cssClass="form-select" selectedOption={srchArchiveName}
                        availableOptions={archivesList} onOptionSelect={onArchiveSelect} />
                </div>
                <div className="col-sm-2">
                    <label htmlFor="srchFolderName">Folder Name:</label>
                </div>
                <div className="col-sm-4">
                    <input type="text" className="form-control" placeholder="Search Files under Folder"
                        name="srchFolderName" value={srchFolderName} onChange={e => setSrchFolderName(e.target.value)}></input>
                </div>
            </div>
            <div class="row mb-3">
                <div className="col-sm-2">
                    <label htmlFor="srchVidName">File Name:</label>
                </div>
                <div className="col-sm-4">
                    <input type="text" className="form-control" placeholder="Partial or Full File Name"
                        name="srchVidName" value={srchVidName} onChange={e => setSrchVidName(e.target.value)}></input>
                </div>
                <div className="col-sm-2">
                    &nbsp;
                </div>
                <div className="col-sm-4 text-end">
                    <button className="btn btn-primary" onClick={fetchVideosData}>Submit</button>
                </div>
            </div>
            <TreeGridComponent dataSource={videosData} treeColumnIndex={0} childMapping='children'
                height="580"
                allowPaging={false}
                allowFiltering={false}
                filterSettings={{
                    mode: "Immediate",
                    type: "Menu",
                    hierarchyMode: "Parent",
                }}>
                <ColumnsDirective>
                    <ColumnDirective field='itemType' headerText='Type' width='70' />
                    <ColumnDirective field='itemName' headerText='Item Name' width='260' />
                    <ColumnDirective field='extension' headerText='Extension' width='40' />
                    <ColumnDirective field='creationDate' headerText='Creation Date' width='90' format='yMd' textAlign='Right' type='date' />
                    <ColumnDirective field='size' headerText='Size' width='80' textAlign='Right' />
                </ColumnsDirective>
                <Inject services={[Filter]} />
            </TreeGridComponent>
            {loading && <div className='overlay'></div>}
        </div>
    );
}